module.exports = "<!-- <div class=\"sidebar-header\"></div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module id = ./src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module chunks = main